import { Injectable, inject } from '@angular/core';
import { AlertStatisticsStore } from '../stores/alert-statistics.store';
import { AlertStatistics } from '../../public-api';

@Injectable({
  providedIn: 'root',
})
export class AlertStatisticsService {
  private alertStatisticsStore = inject(AlertStatisticsStore);

  // ==================== Expose Store Signals ====================
  readonly isLoading = this.alertStatisticsStore.loading;
  readonly alertStatistics = this.alertStatisticsStore.alertStatistics;
  readonly lastUpdated = this.alertStatisticsStore.lastUpdated;
  readonly error = this.alertStatisticsStore.error;

  // ==================== Computed Signals ====================
  readonly hasStatistics = this.alertStatisticsStore.hasStatistics;
  readonly criticalObjectsCount = this.alertStatisticsStore.criticalObjectsCount;
  readonly criticalSensorsCount = this.alertStatisticsStore.criticalSensorsCount;
  readonly alertsCount = this.alertStatisticsStore.alertsCount;
  readonly notificationsCount = this.alertStatisticsStore.notificationsCount;
  readonly hasCriticalObjects = this.alertStatisticsStore.hasCriticalObjects;
  readonly hasCriticalSensors = this.alertStatisticsStore.hasCriticalSensors;
  readonly hasAlerts = this.alertStatisticsStore.hasAlerts;
  readonly hasNotifications = this.alertStatisticsStore.hasNotifications;

  // ==================== Methods ====================

  async updateReportingNumbers(): Promise<AlertStatistics> {
    return this.alertStatisticsStore.fetchAlertStatistics();
  }

  getStats(): AlertStatistics | null {
    return this.alertStatisticsStore.getCurrentStatistics();
  }

  clear(): void {
    this.alertStatisticsStore.clear();
  }

  clearError(): void {
    this.alertStatisticsStore.clearError();
  }
}
